import axios from 'axios';
import {
  Form,
    Link,
    useLoaderData,
    useNavigate,
    redirect
  } from "react-router-dom";
import { Button, Card, Table, FileInput } from 'react-daisyui'
import { LoaderData } from '../../../../types/LoaderData';
import Participant from "../../../../interfaces/participant";


export async function loader({ params } : any) {
  //const surveys: Array<Survey> = await (await axios.get('/api/v1/surveys')).data;
  const participant: Participant = await (await axios.get(`/api/v1/participants/${params.participantId}`)).data;
  return { participant };
}

// export async function action({ request, params } : {request: Request, params: any}) {
//   // Extract formData from captured request
//   const formdata = await request.formData()

//   const surveyID = '461965'

//   // Send Form data to correct path
//   const {data} = await axios.post(`api/participants/${surveyID}/upload/`, formdata, {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
//   return null;
// }

export default function Index() {
  // If its relevent in the future for what were doing with Lo
  const navigate = useNavigate();


  const { participant } = useLoaderData() as LoaderData<typeof loader>;

  return (
      <div className='overflow-x-auto'>
       Hello, {participant.CFirname}

       <p>Insert a partcipant form here below to edit participant info.</p>
      </div>
  );
}